<div class="mailsFolders__container">
  <div class="mailsFolders__header">
    <div class="row">
      <div class="col-12">
        <div class="mailsFolders__body">
          <div class="row">
            <div class="col-12" cdkDropList>
              @for (boxes of boxesIndex; track boxes; let i = $index) {
                <div class="foldersContainer" cdkDrag [cdkDragDisabled]="!editMode" [ngClass]="{ 'd-none': i === 2 && boxes.length === 0 }">
                  @if (i === 0) {
                    <div class="folders__mainTitle mb-2 d-flex align-items-center justify-content-between">
                      <span>{{ 'homeCourrier.superBox.folders' | translate }}</span>
                      @if (!editMode) {
                        <span class="blueReorder" (click)="editMode = !editMode">
                          <svg
                            width="7px"
                            height="12px"
                            viewBox="0 0 7 12"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            style="margin-top: -2px">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <g id="Medium-Copy-38" transform="translate(-401, -120)" fill="#60CDFF" fill-rule="nonzero">
                                <g id="noun-reorder-1297596" transform="translate(401, 120)">
                                  <path
                                    d="M6.60424291,6.86777028 C6.96590883,6.81071444 7.10456283,6.99166526 6.91547412,7.27004002 L3.84371039,11.7909 C3.65400971,12.0701144 3.34587786,12.0692853 3.15679705,11.7909 L0.0850333231,7.27004002 C-0.104667364,6.99082559 0.0333667634,6.81043925 0.396264529,6.86777028 L0.452866379,6.87659043 C2.13595806,7.14202073 4.86501527,7.14188313 6.54775161,6.87659043 L6.60424291,6.86777028 Z M0.395757089,5.13222972 C0.0340911713,5.18928556 -0.104562829,5.00833474 0.0845258827,4.72995998 L3.15628961,0.209100031 C3.34599029,-0.0701144038 3.65412214,-0.0692853089 3.84320295,0.209100031 L6.91496668,4.72995998 C7.10466736,5.00917441 6.96663324,5.18956075 6.60373547,5.13222972 L6.54713362,5.12340957 C4.86404194,4.85797927 2.13498473,4.85811687 0.452248388,5.12340957 L0.395757089,5.13222972 Z"
                                    id="Shape"></path>
                                </g>
                              </g>
                            </g>
                          </svg>
                          {{ 'homeCourrier.superBox.modify' | translate }}</span
                        >
                      }
                      @if (editMode) {
                        <span class="greenReorder" (click)="editMode = !editMode; save()"
                          ><i class="bi bi-check-circle-fill me-2"></i>{{ 'homeCourrier.superBox.confirm' | translate }}</span
                        >
                      }
                    </div>
                  }
                  @if (i === 2) {
                    <div class="folders__mainTitle mt-3">{{ 'homeCourrier.superBox.saveSearch' | translate }}</div>
                  }
                  <div
                    cdkDropList
                    [id]="indexes[i]"
                    [cdkDropListConnectedTo]="getOthers(i)"
                    [cdkDropListData]="boxes"
                    (cdkDropListDropped)="drop(boxes, $event)">
                    <!-- ! Favoris -->
                    @if (i === 0) {
                      <div>
                        <!-- Mode visualisation -->
                        @if (!editMode) {
                          <div>
                            @for (box of boxes | filterByPropertyGiven: 'hideFromPersonalDashboard' : 'false'; track box) {
                              <div
                                class="col-12 mb-2 folders__content"
                                (click)="function(box, box.click, $event)"
                                [style.borderRadius]="'12px'"
                                [style.backgroundColor]="box?.backgroundColor">
                                <div class="folders__title">
                                  <i [ngClass]="{ 'me-2': box?.name !== 'pourAction' }" class="{{ box.icon }}"></i>
                                  <h3 class="super-compos-titre-h3 displayInline">{{ box?.title }}</h3>
                                </div>
                                <div class="folders__count d-flex align-items-center">
                                  <span [style.color]="box?.iconColor" [style.fontSize]="'16px'">{{ box?.count }}</span>
                                  <div class="ms-3 d-flex align-items-center">
                                    <svg
                                      width="13.49px"
                                      height="10.997659px"
                                      viewBox="0 0 13.49 10.997659"
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink">
                                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
                                        <g id="Medium-Copy-38" transform="translate(-312, -752)" fill="#24344B" fill-rule="nonzero">
                                          <g id="Group-3-Copy-2" transform="translate(312, 752)">
                                            <path
                                              d="M13.3,4.98126589 L8.8,0.231265894 C8.54,-0.0787341064 8.03,-0.0687341064 7.74,0.211265894 C7.44,0.491265894 7.42,0.991265894 7.72,1.27126589 L11.02,4.75126589 L0.75,4.75126589 C0.34,4.75126589 0,5.09126589 0,5.50126589 C0,5.91126589 0.34,6.25126589 0.75,6.25126589 L11.01,6.25126589 L7.71,9.73126589 C7.41,10.0112659 7.44,10.5112659 7.73,10.7912659 C8.03,11.0712659 8.54,11.0712659 8.79,10.7612659 L13.29,6.01126589 C13.43,5.86126589 13.49,5.69126589 13.49,5.49126589 C13.49,5.31126589 13.41,5.10126589 13.29,4.97126589 L13.3,4.98126589 Z"
                                              id="Path-Copy-22"></path>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        <!-- Mode édition -->
                        @if (editMode) {
                          <div>
                            @for (box of boxes; track box) {
                              <div
                                class="col-12 mb-2 folders__content"
                                cdkDrag
                                (click)="function(box, box.click, $event)"
                                [style.backgroundColor]="box?.backgroundColor"
                                [style.borderRadius]="'12px'">
                                <div class="folders__title">
                                  <p-checkbox
                                    binary="true"
                                    [trueValue]="'false'"
                                    [falseValue]="'true'"
                                    class="me-2"
                                    [(ngModel)]="box.hideFromPersonalDashboard"
                                    (onChange)="changeBoxHideState($event, box)"></p-checkbox>
                                  <i [ngClass]="{ 'me-2': box?.name !== 'pourAction' }" class="{{ box.icon }}"></i>
                                  <h3 class="super-compos-titre-h3 displayInline">{{ box?.title }}</h3>
                                </div>
                                <div class="folders__count d-flex align-items-center">
                                  @if (editMode) {
                                    <div class="d-flex align-items-center">
                                      <img src="../../../../assets/listIcons/reorder.svg" style="width: 13px" alt="" />
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            <div class="mt-2 col-12 borderBottomDashboardFavorites"></div>
                          </div>
                        }
                      </div>
                    }
                    <!-- ! Autre et Recherches sauvegardées -->
                    @if (i > 0) {
                      <div>
                        <!-- Mode visualisation -->
                        @if (!editMode) {
                          <div>
                            @for (box of boxes | filterByPropertyGiven: 'hideFromPersonalDashboard' : 'false'; track box) {
                              <div
                                class="col-12 folders__content"
                                [ngClass]="{ borderBottomDashboard: box.hideFromPersonalDashboard === 'false' }"
                                (click)="function(box, box.click, $event)">
                                <div class="folders__title">
                                  @if (i !== 2) {
                                    <i [ngClass]="{ 'me-2': box?.name !== 'pourAction' }" class="{{ box.icon }}"></i>
                                  }
                                  @if (i === 2) {
                                    <img src="../../../../assets/listIcons/searchIcon.svg" class="me-2" style="width: 18px" alt="" />
                                  }
                                  <h3 class="super-compos-titre-h3 displayInline">{{ box?.title }}</h3>
                                </div>
                                <div class="folders__count d-flex align-items-center">
                                  <span [style.color]="box?.iconColor" [style.fontSize]="'16px'">{{ box?.count }}</span>
                                  <div class="ms-3 d-flex align-items-center">
                                    <svg
                                      width="13.49px"
                                      height="10.997659px"
                                      viewBox="0 0 13.49 10.997659"
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink">
                                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
                                        <g id="Medium-Copy-38" transform="translate(-312, -752)" fill="#24344B" fill-rule="nonzero">
                                          <g id="Group-3-Copy-2" transform="translate(312, 752)">
                                            <path
                                              d="M13.3,4.98126589 L8.8,0.231265894 C8.54,-0.0787341064 8.03,-0.0687341064 7.74,0.211265894 C7.44,0.491265894 7.42,0.991265894 7.72,1.27126589 L11.02,4.75126589 L0.75,4.75126589 C0.34,4.75126589 0,5.09126589 0,5.50126589 C0,5.91126589 0.34,6.25126589 0.75,6.25126589 L11.01,6.25126589 L7.71,9.73126589 C7.41,10.0112659 7.44,10.5112659 7.73,10.7912659 C8.03,11.0712659 8.54,11.0712659 8.79,10.7612659 L13.29,6.01126589 C13.43,5.86126589 13.49,5.69126589 13.49,5.49126589 C13.49,5.31126589 13.41,5.10126589 13.29,4.97126589 L13.3,4.98126589 Z"
                                              id="Path-Copy-22"></path>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        <!-- Mode édition -->
                        @if (editMode) {
                          <div>
                            @for (box of boxes; track box) {
                              <div
                                class="col-12 folders__content"
                                cdkDrag
                                [ngClass]="{ borderBottomDashboard: box.hideFromPersonalDashboard === 'false' }"
                                (click)="function(box, box.click, $event)">
                                <div class="folders__title">
                                  @if (i === 1) {
                                    <p-checkbox
                                      binary="true"
                                      [trueValue]="'false'"
                                      [falseValue]="'true'"
                                      class="me-2"
                                      [(ngModel)]="box.hideFromPersonalDashboard"
                                      (onChange)="changeBoxHideState($event, box)"></p-checkbox>
                                  }
                                  <i [ngClass]="{ 'me-2': box?.name !== 'pourAction' }" class="{{ box.icon }}"></i>
                                  @if (i === 2) {
                                    <i class="bi bi-search"></i>
                                  }
                                  <h3 class="super-compos-titre-h3 displayInline">{{ box?.title }}</h3>
                                </div>
                                <div class="folders__count">
                                  @if (i === 2) {
                                    <div (click)="deleteSaveSearch(box)" class="me-2">
                                      <svg
                                        width="23px"
                                        height="23px"
                                        viewBox="0 0 23 23"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <title>Group 16</title>
                                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                          <g id="Medium-Copy-39" transform="translate(-416, -802)" fill="#FF6260">
                                            <g id="Group-16" transform="translate(416, 802)">
                                              <path
                                                d="M9.5,15 C9.76785714,15 10,14.8209366 10,14.6143251 L10,10.3856749 C10,10.1790634 9.76785714,10 9.5,10 C9.23214286,10 9,10.1790634 9,10.3856749 L9,14.6143251 C9,14.8347107 9.23214286,15 9.5,15 Z"
                                                id="Path-Copy-3"
                                                fill-rule="nonzero"></path>
                                              <path
                                                d="M11.5,15 C11.7678571,15 12,14.8209366 12,14.6143251 L12,10.3856749 C12,10.1790634 11.7678571,10 11.5,10 C11.2321429,10 11,10.1790634 11,10.3856749 L11,14.6143251 C11,14.8347107 11.2321429,15 11.5,15 Z"
                                                id="Path-Copy-2"
                                                fill-rule="nonzero"></path>
                                              <path
                                                d="M13.5,15 C13.7678571,15 14,14.8209366 14,14.6143251 L14,10.3856749 C14,10.1790634 13.7678571,10 13.5,10 C13.2321429,10 13,10.1790634 13,10.3856749 L13,14.6143251 C13,14.8347107 13.2142857,15 13.5,15 Z"
                                                id="Path-Copy"
                                                fill-rule="nonzero"></path>
                                              <path
                                                d="M15.9553073,6.41324921 L13.2145251,6.41324921 L13.2145251,6.05993691 C13.2145251,5.47949527 12.747486,5 12.1821229,5 L10.8055866,5 C10.2402235,5 9.77318436,5.47949527 9.77318436,6.05993691 L9.77318436,6.41324921 L7.03240223,6.41324921 C6.46703911,6.41324921 6,6.89274448 6,7.47318612 L6,7.82649842 C6,8.40694006 6.46703911,8.88643533 7.03240223,8.88643533 L7.03240223,15.9400631 C7.03240223,16.5205047 7.49944134,17 8.06480447,17 L14.9351955,17 C15.5005587,17 15.9675978,16.5205047 15.9675978,15.9400631 L15.9675978,8.87381703 C16.5329609,8.87381703 17,8.39432177 17,7.81388013 L17,7.46056782 C16.9877095,6.88012618 16.5206704,6.41324921 15.9553073,6.41324921 Z M10.4614525,6.05993691 C10.4614525,5.87066246 10.6212291,5.70662461 10.8055866,5.70662461 L12.1821229,5.70662461 C12.3664804,5.70662461 12.526257,5.87066246 12.526257,6.05993691 L12.526257,6.41324921 L10.4614525,6.41324921 L10.4614525,6.05993691 Z M15.2670391,15.9274448 C15.2670391,16.1167192 15.1072626,16.2807571 14.922905,16.2807571 L8.06480447,16.2807571 C7.88044693,16.2807571 7.72067039,16.1167192 7.72067039,15.9274448 L7.72067039,8.87381703 L15.2793296,8.87381703 L15.2793296,15.9274448 L15.2670391,15.9274448 Z M16.2994413,7.82649842 C16.2994413,8.01577287 16.1396648,8.17981073 15.9553073,8.17981073 L7.03240223,8.17981073 C6.84804469,8.17981073 6.68826816,8.01577287 6.68826816,7.82649842 L6.68826816,7.47318612 C6.68826816,7.28391167 6.84804469,7.11987382 7.03240223,7.11987382 L15.9553073,7.11987382 C16.1396648,7.11987382 16.2994413,7.28391167 16.2994413,7.47318612 L16.2994413,7.82649842 Z"
                                                id="Shape-Copy-2"
                                                stroke="#FF6260"
                                                stroke-width="0.4"
                                                fill-rule="nonzero"></path>
                                              <circle id="Oval-Copy-3" opacity="0.2" cx="11.5" cy="11.5" r="11.5"></circle>
                                            </g>
                                          </g>
                                        </g>
                                      </svg>
                                    </div>
                                  }
                                  @if (editMode) {
                                    <div class="d-flex align-items-center">
                                      <img src="../../../../assets/listIcons/reorder.svg" style="width: 13px" alt="" />
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="cdk-placeholder" [style.height.px]="getHeight(boxes)" *cdkDragPlaceholder></div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog [contentStyle]="{ 'min-width': '360px' }" [(visible)]="openModal" modal="true" appendTo="body">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'homeCourrier.superBox.addNewFilter' | translate }}</h5>
      <button class="super-compos-secondary-btn-noshadow" (click)="submit()">{{ 'homeCourrier.superBox.toValid' | translate }}</button>
    </div>
  </p-header>
  <div class="modal-body">
    <form class="row" [formGroup]="filterForm" (submit)="submit()">
      <div class="col-md-12 mb-3">
        <label class="super-compos-super-compos-label-input font-weight-bold text-uppercase" for="name">{{
          'homeCourrier.superBox.sessionTitle' | translate
        }}</label>
        <input type="text" class="form-control" formControlName="Title" autofocus />
      </div>
    </form>
  </div>
</p-dialog>

<p-confirmDialog
  baseZIndex="560"
  #cd
  [header]="'global.confirmHeader' | translate"
  styleClass="super-compos-modal-content confirmModal"
  icon="bi bi-exclamation-triangle">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
